import { ArrowBackOutlined } from "@mui/icons-material";
import { IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { useEffect, useState } from "react";
import { setAlert } from "../../../redux/slices/alertSlice";
import {
  addUser,
  getAllUsers,
  onChangeUsersScreen,
  updateUser,
} from "../../../redux/slices/users.slice";
import UserInfo from "./UserInfo";
import PreviewUser from "./PreviewUser";
import { v4 as uuidv4 } from "uuid";

const initialData = {
  userId: "",
  name: "",
  email: "",
  phoneNo: "",
  password: "",
  roleId: "",
  isBlocked: true,
  createdDate: "",
  updatedDate: "",
  createdBy: "",
  updatedBy: "",
  isDelete: true,
  stations: "",
  roleName: "",
};

const tabs = ["User Information", "Preview"];

const AddUser = ({
  isEdit,
  defaultData,
}: {
  isEdit: boolean;
  defaultData: any;
}) => {
  const { loading, selectedUser } = useSelector(
    (state: RootState) => state.users
  );
  const [userInfo, setUserInfo] = useState(isEdit ? defaultData : initialData);
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (selectedUser) {
      setUserInfo(selectedUser);
    }
  }, [selectedUser]);

  const dispatch = useDispatch<AppDispatch>();

  const onGoBack = () => {
    const tabNumber = currentTab;
    if (tabNumber === 0) {
      return;
    }
    if (tabNumber === 1) {
      setCurrentTab(0);
    }
    if (tabNumber === 2) {
      setCurrentTab(1);
    }
    if (tabNumber === 3) {
      setCurrentTab(2);
    }
    if (tabNumber === 4) {
      setCurrentTab(3);
    }
    if (tabNumber === 5) {
      setCurrentTab(4);
    }
  };

  const saveData = (userInfo: any, isLast: boolean) => {
    const payload = {
      ...userInfo,
      createdDate: isEdit ? userInfo.createdDate : new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      createdBy: isEdit ? userInfo.createdBy : "Admin",
      updatedBy: "Admin",
      roleId: null,
      phoneNo: userInfo.phoneNo?.includes("+")
        ? userInfo.phoneNo?.replace(/^\+/, "").replace(/\s/g, "")
        : userInfo.phoneNo,
      stations: userInfo.stations?.toString() ?? "",
      userId: isEdit ? userInfo.userId : uuidv4(),
    };
    delete payload.confirmPassword;

    dispatch(isEdit ? updateUser(payload) : addUser(payload))
      .then((res) => {
        if (
          res?.payload?.responseCode === "200" ||
          typeof res.payload === "string"
        ) {
          dispatch(
            setAlert({
              message: res?.payload?.responseMessage ?? res?.payload,
              severity: "success",
            })
          );
          if (!isLast && !isEdit) {
            setUserInfo({
              ...userInfo,
              id: Number(res?.payload?.result),
            });
          }
          if (isLast) {
            setUserInfo(initialData);
            dispatch(getAllUsers());
            dispatch(onChangeUsersScreen("list"));
          }
        }
      })
      .catch(console.log);
  };
  const onSaveAndNext = (e: any, tabNumber: any) => {
    setUserInfo({ ...userInfo, ...e });
    if (tabNumber === 1) {
      setCurrentTab(1);
    } else if (tabNumber === 2) {
      saveData({ ...userInfo, ...e }, true);
    }
  };

  const getCurrentTab = (tabName: string) => {
    switch (tabName) {
      case tabs[0]:
        return (
          <UserInfo
            onSaveAndNext={onSaveAndNext}
            defaultData={userInfo}
            isEdit={isEdit}
          />
        );
      case tabs[1]:
        return (
          <PreviewUser
            onSaveAndNext={onSaveAndNext}
            selectedUser={userInfo}
            onGoBack={onGoBack}
            loading={loading}
          />
        );

      default:
        return;
    }
  };

  return (
    <div className="h-full">
      <div className="flex gap-4 items-center">
        <IconButton onClick={() => dispatch(onChangeUsersScreen("list"))}>
          <ArrowBackOutlined />
        </IconButton>
        <Typography className="font-bold" variant="h5">
          {isEdit ? "Edit User" : "Add User"}
        </Typography>
      </div>
      <div className="border border-gray-800 rounded-md px-4 py-4 my-2 h-full">
        <div>
          <Tabs
            value={currentTab}
            onChange={() => {}}
            aria-label="Navigation tabs"
            className="border-slate-400 border-b border-neutral-500	"
            variant="scrollable"
            selectionFollowsFocus
            classes={{
              root: "tabRoot",
            }}
          >
            {tabs.map((link: string) => (
              <Tab
                label={link}
                key={link}
                classes={{
                  root: "tabHeight rounded-t-md",
                  selected: "textWhite bg-primary-light",
                }}
              />
            ))}
          </Tabs>
          <div className="p-2">{getCurrentTab(tabs[currentTab])}</div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
